module.exports = __webpack_public_path__ + "img/CCCal45.d3a96de3.png";